import { React, useState, useEffect } from "react";
import {
  getColor,
  getIcon,
  formatNumber,
} from "../../constants/commonFunction";
import BigBox from "../BigBox.js";
import Box from "../Box.js";
import OtherService from "../../services/Other.js";

const PerformaceTrackerDealer = (props) => {
  const [data, setData] = useState([]);
  const [count, setCount] = useState({});
  const [businessTimeframe, setBusinessTimeframe] = useState("MTD");
  const [hierName, setHiername] = useState(null);
  const [loading, setLoading] = useState(false); 

  const brandId = JSON.parse(localStorage.getItem("currentBrand")).id;
  const userData = JSON.parse(localStorage.getItem("userData"));

    useEffect(() => {
      trigger();
    }, [brandId]);
  
  const trigger = async () => {
    const hierDesc = JSON.parse(localStorage.getItem("userData")).hierCode;
    setHiername(hierDesc);
    if (hierDesc != "TSE") {
      loyaltyPerformanceData(businessTimeframe);
    }
  };

  const loyaltyPerformanceData = async (val) => {
    try {
        setLoading(true);
        let payload = {
          business_timeframe: val,
        };
      const res = await OtherService.getDealerLoyaltyPerformanceData(payload);
      if(res.success) {
        let arr = [];
        for (let [key, value] of Object.entries(res?.response)) {
          if (
            String(key).includes('dealer_Total_Sale_Target') 
            // || String(key).includes('dealer_Total_Volume') ||
            // String(key).includes('member_Contractor_Count') ||
            // String(key).includes('achieved_Target')
          ) {
            arr.push({
              color: getColor(key),
              value: value,
              label: String(
                "Target (MT)"
                // key.split('_').join(' ')
              ),
            });
          }

          if(String(key).includes('dealer_Total_Volume')) {
            arr.push({
                color: getColor(key),
                value: value,
                label: String(
                  "Total Volume (MT)"
                ),
              });
          }

          if(String(key).includes('member_Contractor_Count')) {
            arr.push({
                color: getColor(key),
                value: value,
                label: String(
                  "Enrolled Contractors"
                ),
              });
          }

          if(String(key).includes('achieved_Target')) {
            arr.push({
                color: getColor(key),
                value: value,
                label: String(
                  "Achievement (%) against Target"
                ),
              });
          }
        }
        setData(arr);
      } 
    } catch (error) {
      console.error("loyaltyPerformanceData api error");
    } finally {
       setLoading(false);
    }
  }

  const changeBusinessTimeFrameService = (option) => {
    setBusinessTimeframe(option);
    loyaltyPerformanceData(option);
  };

  return (
    <>
      <BigBox 
        header="Loyalty Performance Tracker"
        options={["MTD", "YTD"]}
        selectedOption={businessTimeframe}
        onChange={changeBusinessTimeFrameService}
      >
        {/* {data?.length > 0 &&
          data.map((item, index) => {
            return (
              <>
                <Box bgColor={item?.color}>
                  <p className="text-[18px] font-bold">
                    {item?.value}
                  </p>
                  <p className="capitalize text-[#000] text-[12px] text-center flex-shrink tracking-wide font-sans">
                    {item?.label}
                  </p>
                </Box>
              </>
            );
          })}
        {data?.length == 0 && (
          <p
            className="text-[18px] font-bold font-sans text-slate-600 text-center"
            style={{ color: "rgb(100 116 139)" }}
          >
            No data found !!!
          </p>
        )} */}
        {loading ? (
  <div
    style={{
      padding: "16px",
      display: "flex",
      justifyContent: "center",
      color: "#000",
      maxHeight: "112px",
      minWidth: "202px",
      minHeight: "112px"
    }}
  >
    <p className="text-[16px] text-slate-600 font-medium">Loading...</p>
  </div>
) : Array.isArray(data) && data.length > 0 ? (
  data.map((item, index) => (
    <Box bgColor={item?.color} key={index}>
      <p className="text-[18px] font-bold">{item?.value}</p>
      <p className="capitalize text-[#000] text-[12px] text-center flex-shrink tracking-wide font-sans">
        {item?.label}
      </p>
    </Box>
  ))
) : (
  <p
    className="text-[18px] font-bold font-sans text-slate-600 text-center"
    style={{ color: "rgb(100 116 139)" }}
  >
    No data found !!!
  </p>
)}

      </BigBox>
    </>
  );
};

export default PerformaceTrackerDealer;
